var _ellipse, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoalProcessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 105,
    viewBox: "0 0 107 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.1717,
    cy: 52.1291,
    rx: 53.1717,
    ry: 52.1291,
    fill: "#2B2F86",
    fillOpacity: 0.04
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 79C66.8071 79 78 67.8071 78 54C78 40.1929 66.8071 29 53 29C39.1929 29 28 40.1929 28 54C28 67.8071 39.1929 79 53 79ZM53.0005 74.7548C64.4629 74.7548 73.7552 65.4624 73.7552 54C73.7552 42.5375 64.4629 33.2453 53.0005 33.2453C41.5379 33.2453 32.2457 42.5375 32.2457 54C32.2457 65.4624 41.5379 74.7548 53.0005 74.7548Z",
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6588 29.3798C43.7894 30.2384 39.2839 32.5217 35.7122 35.9409C32.1404 39.3601 29.6628 43.7617 28.5926 48.589C27.5224 53.4164 27.9077 58.4526 29.6998 63.061C31.4919 67.6693 34.6103 71.6426 38.6606 74.4788C42.7109 77.3148 47.5113 78.8862 52.4545 78.994C57.3981 79.1019 62.2624 77.7414 66.4324 75.0848C70.6026 72.4281 73.8914 68.5945 75.8829 64.0686C77.8743 59.5429 78.4788 54.5281 77.6202 49.6588L73.4857 50.3878C74.2002 54.4395 73.6971 58.6121 72.04 62.3779C70.3831 66.1436 67.6467 69.3333 64.1767 71.544C60.7069 73.7545 56.6595 74.8864 52.5462 74.7967C48.433 74.7071 44.4388 73.3995 41.0686 71.0398C37.6985 68.68 35.1038 65.3738 33.6126 61.5393C32.1215 57.7048 31.8009 53.5143 32.6914 49.4977C33.5818 45.481 35.6434 41.8186 38.6153 38.9736C41.5873 36.1286 45.3361 34.2287 49.3878 33.5143L48.6588 29.3798Z",
    fill: "#6750A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(28 29)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoalProcessIcon);
export default __webpack_public_path__ + "static/media/moal-process-icon.81fea03d094eecead437c964009fdb9a.svg";
export { ForwardRef as ReactComponent };